// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    POSTPAGE_LOADING() {
      return {
        isLoading: true,
        postpage: action.postpage
      };
    },
    POSTPAGE_LOADED() {
      const currentState = store.getState();
      const postData = get(currentState, 'post.data.post');
      const supertags = get(currentState, 'supertags.supertags');
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        postData,
        'postPage',
        supertags
      );

      return {
        isLoading: false,
        data: get(action, 'postpage'),
        ads: adModelData,
        postScrollDepth: 0
      };
    },
    POSTPAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postpage.errorMessage
      };
    },
    POSTPAGE_SCROLL_DEPTH() {
      return {
        isLoading: state.isLoading,
        data: state.postpage,
        ads: state.ads,
        postScrollDepth: action.postScrollDepth
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
